<template>
    <div>
        <slot
            :items="results"
            :filters="filters"
            :processresults="processResults"
            :opendialog="openDialog"
            :event="event"
            :scrolltoday="scrollToDay"
        >
        </slot>
    </div>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue';
import { cloneDeep, flatten, uniqBy } from 'lodash';
import Fuse from 'fuse.js';
import { getPerformances } from '../services/inventory';
import { format } from 'date-fns';

export default defineComponent({
    name: 'WhatsOnCalendar',
    props: {
        filterAccessibilityDescription: {
            type: String,
            default: '',
        },
    },
    setup(props) {
        const results = ref([]);
        const filters = ref([]);
        const performances = ref([]);
        const fuse = ref(null);
        const can_reset = ref(false);
        const total_results = ref(0);
        const event = ref({});

        const setupFilters = (() => {
            let aggregatedFilters = [
                // {
                //     title: 'Event Season',
                //     field: 'event_seasons',
                //     facets: [],
                // },
                {
                    title: 'Event Series',
                    field: 'event_series',
                    facets: [],
                },
                {
                    title: 'Event Type',
                    field: 'event_types',
                    facets: [],
                },
                {
                    title: 'Venues',
                    field: 'venues',
                    facets: [],
                },
                {
                    title: 'Event Tags',
                    field: 'keywords',
                    facets: [],
                }
            ];

            aggregatedFilters = aggregatedFilters.map(filter => {
                let facets = performances.value.map(item => {
                    return cloneDeep(item.filters[filter.field]);
                });

                facets = flatten(facets);

                facets = uniqBy(facets, facet => {
                    return facet.title;
                });

                filter.facets = facets.map(facet => {
                    facet.is_checked = false;
                    facet.is_disabled = false;

                    return facet;
                });

                return filter;
            });

            filters.value = aggregatedFilters;
        });

        const processResults = (() => {
            const andQuery = [];

            for (const filter of filters.value) {
                const orQuery = [];

                for (const facet of filter.facets) {
                    if (facet.is_checked) {
                        orQuery.push({
                            [`filters.${filter.field}.title`]: facet.title,
                        })
                    }
                }

                if (orQuery.length) {
                    andQuery.push({
                        ['$or']: orQuery,
                    });
                }
            }

            let performancesResults = performances.value;
            let canReset = false;

            if (andQuery.length) {
                performancesResults = fuse.value.search({
                    '$and': andQuery,
                }).map(result => {
                    return result.item;
                });

                canReset = true;
            }

            results.value = performancesResults;
            can_reset.value = canReset;
            total_results.value = performancesResults.length;
        });

        const openDialog = (e) => {
            event.value = e;
        };

        const scrollToDay = (day => {
            const dayElement = document.getElementById('day-' + day.date);

            if (!dayElement) {
                return;
            }

            setTimeout(() => {
                const intersectionObserver = new IntersectionObserver(entries => { // eslint-disable-line compat/compat
                    if (entries[0].isIntersecting) {
                        dayElement.classList.add('focused');
                        intersectionObserver.disconnect();
                    }
                });

                intersectionObserver.observe(dayElement);

                dayElement.addEventListener('animationend', () => {
                    dayElement.classList.remove('focused');
                });

                dayElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            }, 50);
        })

        onMounted(() => {
            getPerformances().then(performancesResponse => {
                performances.value = performancesResponse;

                setupFilters();

                fuse.value = new Fuse(performances.value, {
                    threshold: 0.40,
                    useExtendedSearch: true,
                    includeScore: false,
                    shouldSort: false,
                    keys: [
                        'filters.event_types.title',
                        'filters.venues.title',
                        'filters.event_series.title',
                        //'filters.event_seasons.title',
                        'filters.keywords.title',
                    ],
                });

                processResults();
            });
        });

        return {
            filters,
            results,
            processResults,
            performances,
            openDialog,
            event,
            scrollToDay,
        };
    },
});
</script>
